import Project from "../project";


export default function projectSetOwner(project:Project, userId:ID|null) {

    // akkurtanot bil bug v project info change owner

    const curOwnerUser = _.find(project.users, (u)=>u.id !== userId && u.role === gd.const.project.role.OWNER);

    //if found owner user other than passed (id) change from owner to simple user
    if (curOwnerUser) curOwnerUser.role = gd.const.project.role.USER;



    if (!userId) {
        // id can be empty!
        project._ownerUserId = null
    } else {

        project._ownerUserId = userId

        const projectUser = _.find(project.users, (u)=>{
            // tut koroche v raznih cases raznii key dlya userId ... nodo strandard !
            return u.id === userId || u.userId === userId
        })

        if (projectUser) {
            projectUser.role = gd.const.project.role.OWNER; //if user found in users list then just change it's role
        } else {
            if (project.users) {
                //if user not found in users list then add new to users list
                project.users.unshift({ role: gd.const.project.role.OWNER, id: userId });
            }
        }
    }

}